import ReactDOM from "react-dom/client";
// import './config/liveblocks'; // Adjust this path if your firebase config file is elsewhere
import './Utils/firebaseConfig'; // Or your firebase initialization file

import App from "./App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
root.render(
  // <StrictMode>
    <App />
  // </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    try {
      const waiting = registration && registration.waiting;
      if (waiting) {
        waiting.postMessage({ type: 'SKIP_WAITING' });
        const listenForActivation = () => {
          if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            window.location.reload();
          } else {
            setTimeout(listenForActivation, 150);
          }
        };
        listenForActivation();
      } else {
        registration.update();
      }
    } catch (_) {
      window.location.reload();
    }
  }
});
